import { t } from '@lingui/macro';
// @ts-ignore: tsc declarations not recognising types/index.d.ts
import PipeIcon from '@bechtel/client-assets/dist/images/pipe-icon.svg';
// @ts-ignore: tsc declarations not recognising types/index.d.ts
// TODO: uncomment below data once BE start provide the data for the same.
// import SteelIcon from '@bechtel/client-assets/dist/images/steel-icon.svg';
// // @ts-ignore: tsc declarations not recognising types/index.d.ts
// TODO: uncomment below data once BE start provide the data for the same.
// import DataVaultIcon from '@bechtel/client-assets/dist/images/data-vault-icon.svg';
// @ts-ignore: tsc declarations not recognising types/index.d.ts
import RodRoomIcon from '@bechtel/client-assets/dist/images/rod-room-icon.svg';
import { MarkerFilter, MarkerType } from './types';

export const markerFilters: MarkerFilter[] = [
  { value: MarkerType.PIPING, label: t`Piping`, icon: PipeIcon },
  { value: MarkerType.ROD_ROOM, label: t`Rod Room`, icon: RodRoomIcon },
];
